module.exports = __webpack_public_path__ + "img/ht.800c2d43.svg";